import { KeyPath, TemplateEditorAction, TemplateEditorValue } from '../../../templateeditor-types';
import {
  TEMPLATE_UPDATE_FIELD_ADDCHECKBOXESTOGROUP,
  TEMPLATE_UPDATE_FIELD_CHECKBOXGROUPITEMS,
  TEMPLATE_UPDATE_FIELD_GROUPCHECKBOXES,
  TEMPLATE_UPDATE_FIELD_UNGROUPCHECKBOX
} from './actionTypes';

export const templateEditorCreateCheckboxGroup = (keyPaths: KeyPath[], groupName: string): TemplateEditorAction => ({
  type: TEMPLATE_UPDATE_FIELD_GROUPCHECKBOXES,
  undoable: true,
  payload: {
    keyPaths,
    name: groupName
  }
});

export const templateEditorUngroupCheckbox = (keyPaths: KeyPath[]): TemplateEditorAction => ({
  type: TEMPLATE_UPDATE_FIELD_UNGROUPCHECKBOX,
  undoable: true,
  payload: {
    keyPaths
  }
});

export const templateEditorAddCheckboxesToGroup = (keyPaths: KeyPath[]): TemplateEditorAction => ({
  type: TEMPLATE_UPDATE_FIELD_ADDCHECKBOXESTOGROUP,
  undoable: true,
  payload: {
    keyPaths
  }
});

export const createCheckboxGroup = () => ({
  type: TEMPLATE_UPDATE_FIELD_GROUPCHECKBOXES,
  undoable: true
});

export const templateEditorUpdateFieldCheckBoxGroupItems = (keyPaths: KeyPath[], value: TemplateEditorValue): TemplateEditorAction => ({
  type: TEMPLATE_UPDATE_FIELD_CHECKBOXGROUPITEMS,
  undoable: true,
  payload: { keyPaths, value }
});
